var module = 'kiosk', name = 'kiosk/config/locales/en.json', content = {
  "kiosk": {
    "login_title": "Self check-in",
    "home": {
      "title": "Self check-in",
      "user_login": {
        "label": "Health insurance number",
        "placeholder": "AAAA 1111 1111",
        "submit": "Report my arrival"
      },
      "info": "The clinic offers you the opportunity to self check-in quickly, without having to go to the front desk.<br/><br/><strong>Just identify yourself with your health insurance number.</strong>",
      "feedback_message": "<strong>Note:</strong> just enter your health insurance number and all appointments of people associated with your account will be confirmed when you register."
    },
    "appointments": {
      "found_appointment_title": "Appointment found",
      "found_appointment_content": "Do you want to check-in for this appointment ?",
      "found_multiple_appointments_title": "Several appointments found",
      "found_multiple_appointments_content": "Do you want to check-in all the appointments or go to the front desk ?",
      "confirm_appointment": "Check-in",
      "confirmed_appointments_title": "Check-in confirmed",
      "confirmed_appointments_content": "Your presence has been successfully reported to our staff. Please go to the designated waiting room.",
      "previously_confirmed_appointments_title": "Check-in already confirmed",
      "previously_confirmed_appointments_content": "Your presence has already been successfully reported to our staff. Please go to the waiting room.",
      "confirmed_appointment_note": "<strong>Please note</strong> to ensure proper follow-up of your file, it is important to keep your contact information up-to-date. <strong> You can update your information on the patient portal.</strong>",
      "waiting_room": "Waiting room {{waitingRoom}}"
    },
    "informations": {
      "title": "Validate your information",
      "content": "Is your contact information still accurate?",
      "address": "Address"
    },
    "error": {
      "generic": {
        "title": "An error occured",
        "content": "It is not possible to confirm your arrival at your appointment. <strong>Please go to the front desk.</strong>"
      },
      "hin": {
        "title": "Health insurance card expired",
        "content": "It is not possible to confirm your arrival at your appointment. <strong>Please go to the front desk.</strong>"
      },
      "no_appointments": {
        "title": "No appointment found",
        "content": "Unfortunately, there are no matching appointments in the system. <strong>Please show up at the front desk.</strong>"
      },
      "invalid_informations": {
        "title": "Please go to the front desk to update your contact information and confirm your arrival."
      }
    },
    "back_home": "Back to home page",
    "help": "For any questions or technical assistance, please go to the front desk."
  }
}
;
angular.module(module).run(['$translationCache', function($translationCache) {
  $translationCache.put(name, content);
}]);
module.exports = name;


//////////////////
// WEBPACK FOOTER
// ./kiosk/config/locales/en.json
// module id = 1408
// module chunks = 0